export const URLS = {
  ROOT: "/",
  HOME: "/home",
  LOGIN: "/login",
  BUTTONS: "/buttons",
  TYPOGRAPHY: "/typography",
  FORMS: "/forms",
  MODALS: "/modals",
  ABOUT_OVERVIEW: "/about/overview",
  ABOUT_GRPS: "/about/grps",
  PRIVACY_POLICY: "/privacy/samsung",
  POLICY_OVERVIEW: "/policy/overview",
  COOKIE_POLICY: "/cookie/policy",
  MYDATA: "/my-data",
  MYDATA_HISTORY: "/my-data/history",
  ERROR_400: "/error/400",
  ERROR_403: "/error/403",
  ERROR_404: "/error/404",
  ERROR_500: "/error/500",
  ERROR_502: "/error/502",
  ERROR_503: "/error/503",
  ERROR_IE: "/error/ie",
  OLD_MYDATA: "/mydata",
  OLD_REQUEST_DETAILS: "/details",
  OLD_DOWNLOAD_HISTORY: "/downloads",
  OLD_DELETE_HISTORY: "/delete",
  OLD_OPTOUT_HISTORY: "/preferences",
  OLD_REQUEST_DOWNLOAD: "/downloads/request",
  OLD_REQUEST_DELETE: "/delete/request",
  OLD_REQUEST_OPTOUT: "/preferences/opt-out",
  PARAMS: {
    REQUEST_NUMBER: ":requestNumber",
  },
};
